import React from "react";

import { Editor } from "@hugerte/hugerte-react";
import { useTranslation } from "react-i18next";

import { usePermissions } from "hooks/permission";

import { editorInit } from "services/utils/editor.config";

import { FORMS_HEARING } from "utils/entities/permission";

import { ISummary } from "./interface";
import {
  Container,
  FooterContainer,
  ButtonContainer,
  ContainerTiny,
} from "./styles";
import Button from "../../../../components/Button";
import { StatusContainer, StatusText } from "../styles";
import { TranscriptionStatus } from "../utils";

const Summary: React.FC<ISummary> = ({
  buttonTitle,
  buttonFunction,
  disabledButton,
  status,
  ataRef,
  transcription,
}) => {
  const { t } = useTranslation();
  const { export: exportDownloads } = usePermissions(
    FORMS_HEARING.HEARING_FILE,
  );

  const textPlainSummary =
    transcription && transcription[0] ? transcription[0].textPlainSummary : "";

  return (
    <Container>
      <ContainerTiny id="container_tiny">
        {status === 6 && textPlainSummary ? (
          <Editor
            onInit={(_, editor) => (ataRef ? (ataRef.current = editor) : null)}
            init={editorInit(exportDownloads, false)}
            initialValue={textPlainSummary}
            onCopy={(e) => e.preventDefault()}
            onCut={(e) => e.preventDefault()}
          />
        ) : (
          <StatusContainer>
            {(status === 0 || status !== null) &&
            status >= 0 &&
            status !== 6 ? (
              TranscriptionStatus(status, t)
            ) : (
              <StatusText>
                O resumo estará disponivel assim que a transcrição estiver
                concluída
              </StatusText>
            )}
          </StatusContainer>
        )}
      </ContainerTiny>
      <FooterContainer>
        <ButtonContainer>
          <Button disabled={disabledButton} onClick={buttonFunction}>
            {buttonTitle}
          </Button>
        </ButtonContainer>
      </FooterContainer>
    </Container>
  );
};

export default Summary;
